"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
const react_2 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const store_1 = require("../store");
const Button_1 = __importDefault(require("./Button"));
const ErrorMsgs_1 = __importDefault(require("./ErrorMsgs"));
const BannerStyled = styled_1.default.div(({ position, show, }) => (0, react_1.css) `
    position: fixed;
    ${position}: 0;
    right: 0;
    left: 0;
    z-index: 100;

    width: 100%;
    padding: 0 2rem;
    overflow: hidden;

    transition: all 0.2s;

    ${show &&
    (0, react_1.css) `
      max-height: 8rem;
      opacity: 1;
    `}
    ${!show &&
    (0, react_1.css) `
      max-height: 0;
      opacity: 0;
    `}

    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
    }

    p,
    ul {
      margin: 0;
    }
  `);
const sizes = {
    lg: 1410,
    md: 1170,
    sm: 930,
    xs: 690,
};
const MaxWidthStyled = styled_1.default.div(({ size }) => (0, react_1.css) `
    max-width: ${sizes[size]}px;
  `);
function Banner(_a) {
    var { buttonText = 'Save Changes', position = 'top', size = 'lg', text = 'Changes have been made', buttonCSS = {
        CHANGED: {},
        ERROR: {},
        PENDING: {},
        SUCCESS: {},
        WAITING: {},
    } } = _a, extraProps = __rest(_a, ["buttonText", "position", "size", "text", "buttonCSS"]);
    const formStatus = (0, store_1.useAppSelector)(state => state.status);
    const errors = (0, store_1.useAppSelector)(state => state.errors);
    return (react_2.default.createElement(BannerStyled, Object.assign({ state: formStatus, show: formStatus !== 'WAITING', position: position }, extraProps),
        react_2.default.createElement(MaxWidthStyled, { size: size },
            !errors.length && react_2.default.createElement("p", null, text),
            react_2.default.createElement(ErrorMsgs_1.default, null),
            react_2.default.createElement(Button_1.default, { stateCSS: buttonCSS }, buttonText))));
}
exports.default = Banner;
